import React from "react";
import { createIcon } from "@chakra-ui/icons";
import iloqTheme from "@iloqshared/design-tokens/dist/theme";
import iloqSearch from "@iloqshared/design-tokens/dist/assets/icons/brand/iLOQ-search.svg";

const chakraIcons = iloqTheme.icon.chakra;

export const ProfileIcon = createIcon({
  displayName: "ProfileIcon",
  path: (
    <svg
      viewBox={chakraIcons.profile.viewBox}
      dangerouslySetInnerHTML={{ __html: chakraIcons.profile.path }}
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
});

export const EditIcon = createIcon({
  displayName: "EditIcon",
  path: (
    <svg
      viewBox={chakraIcons.edit.viewBox}
      dangerouslySetInnerHTML={{ __html: chakraIcons.edit.path }}
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
});

export const CalendarIcon = createIcon({
  displayName: "CalendarIcon",
  path: (
    <svg
      viewBox={chakraIcons.calendar.viewBox}
      dangerouslySetInnerHTML={{ __html: chakraIcons.calendar.path }}
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
});

export const SubNavigationIcon = createIcon({
  displayName: "SubNavigationIcon",
  path: (
    <svg
      viewBox={chakraIcons.sub_navigation.viewBox}
      dangerouslySetInnerHTML={{ __html: chakraIcons.sub_navigation.path }}
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
});

export const ThumbsUpIcon = createIcon({
  displayName: "ThumbsUpIcon",
  path: (
    <svg
      viewBox={chakraIcons.thumbs_up.viewBox}
      dangerouslySetInnerHTML={{ __html: chakraIcons.thumbs_up.path }}
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
});

export const ThumbsDownIcon = createIcon({
  displayName: "ThumbsDownIcon",
  path: (
    <svg
      viewBox={chakraIcons.thumbs_down.viewBox}
      dangerouslySetInnerHTML={{ __html: chakraIcons.thumbs_down.path }}
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
});

export const ThumbsNeutralIcon = createIcon({
  displayName: "ThumbsNeutralIcon",
  path: (
    <svg
      viewBox={chakraIcons.thumbs_neutral.viewBox}
      dangerouslySetInnerHTML={{ __html: chakraIcons.thumbs_neutral.path }}
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
});

export const TriangleUpIcon = createIcon({
  displayName: "TriangleUpIcon",
  path: (
    <svg
      viewBox={chakraIcons.triangle_up.viewBox}
      dangerouslySetInnerHTML={{ __html: chakraIcons.triangle_up.path }}
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
});

export const TriangleDownIcon = createIcon({
  displayName: "TriangleDownIcon",
  path: (
    <svg
      viewBox={chakraIcons.triangle_down.viewBox}
      dangerouslySetInnerHTML={{ __html: chakraIcons.triangle_down.path }}
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
});

export const CheckIcon = createIcon({
  displayName: "CheckIcon",
  path: (
    <svg
      viewBox={chakraIcons.check.viewBox}
      dangerouslySetInnerHTML={{ __html: chakraIcons.check.path }}
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
});

export const InfoIcon = createIcon({
  displayName: "InfoIcon",
  path: (
    <svg
      viewBox={chakraIcons.info.viewBox}
      dangerouslySetInnerHTML={{ __html: chakraIcons.info.path }}
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
});

export const MobileIcon = createIcon({
  displayName: "MobileIcon",
  path: (
    <svg
      viewBox={chakraIcons.phone_key.viewBox}
      dangerouslySetInnerHTML={{ __html: chakraIcons.phone_key.path }}
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
});

export const WarningIcon = createIcon({
  displayName: "WarningIcon",
  path: (
    <svg
      viewBox={chakraIcons.alert.viewBox}
      dangerouslySetInnerHTML={{ __html: chakraIcons.alert.path }}
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
});

export const PlusIcon = createIcon({
  displayName: "PlusIcon",
  path: (
    <svg
      viewBox={chakraIcons.plus.viewBox}
      dangerouslySetInnerHTML={{ __html: chakraIcons.plus.path }}
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
});

export const SearchIcon = <img src={iloqSearch} alt="" />;

export const ChevronRightIcon = createIcon({
  displayName: "ChevronRightIcon",
  path: (
    <svg
      viewBox={chakraIcons.chevron_right.viewBox}
      dangerouslySetInnerHTML={{ __html: chakraIcons.chevron_right.path }}
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
});

export const BulletinIcon = createIcon({
  displayName: "BulletinIcon",
  path: (
    <svg
      viewBox={chakraIcons.article_bulletin.viewBox}
      dangerouslySetInnerHTML={{ __html: chakraIcons.article_bulletin.path }}
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
});
export const GlobeIcon = createIcon({
  displayName: "GlobeIcon",
  path: (
    <svg
      viewBox={chakraIcons.globe.viewBox}
      dangerouslySetInnerHTML={{ __html: chakraIcons.globe.path }}
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
});
